export default {
  user: state => state.user,
  managers: state => state.managers,
  error: state => state.error,
  notifications: state => state.user.notifications,
  avatar: state => state.user.username[0] ? state.user.username[0].toUpperCase() : '',
  showSverkaMessage: state => state.showSverkaMessage,
  allowB: state => state.allowB,
  allowBB: state => state.allowBB,
  showBalance: state => state.showBalance,
  tipDostavki: state => state.tipDostavki
}
